import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AccountCreditRefundRequest } from "../shared/AccountCreditRefundRequest";
import { DataService_StudentFinesDebts } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "app-student-fine-refund",
	templateUrl: "./student-fine-refund.component.html",
	styleUrls: ["./student-fine-refund.component.css"],
})
export class StudentFineRefundComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private StudentFinesDebtsService: DataService_StudentFinesDebts
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;
		this.SelectedFine = this.dialogConfig.data.SelectedFine;

		this.UpdateData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	//From parent
	user: any;
	SelectedPerson: any;
	SelectedFine: any;

	//Display Data
	StudentID: any = "";
	StudentName: any = "";
	TransactionDesc: any = "";
	FineDT: any = "";
	AdminName: any = "";
	OriginalComments: any = "";
	OriginalAmount: any = "";
	ItemBalance: any = "";

	//Form
	BalanceOption: any = "EntirePayment"; //EntirePayment or BalanceOnly
	RefundComments: any = "";

	EntireEnabled: any = false;
	BalanceEnabled: any = false;

	errorMessage: any = "";

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	UpdateData() {
		// console.log(this.SelectedFine);

		this.StudentID = this.SelectedPerson.DesignatorID;
		this.StudentName = this.SelectedPerson.PersonName;

		this.FineDT = this.SelectedFine.FineDateDesc;
		this.TransactionDesc = this.SelectedFine.FineTypeDesc;
		this.AdminName = this.SelectedFine.AdminName;

		this.OriginalAmount = this.SelectedFine.PaidDesc; //

		this.ItemBalance = this.SelectedFine.BalanceDesc;
		this.OriginalComments = this.SelectedFine.FineComment;

		//
		// Update which radio buttons are enabled
		//
		if (this.SelectedFine.Balance > 0) {
			if (this.SelectedFine.Balance == this.SelectedFine.Paid) {
				this.EntireEnabled = false;
				this.BalanceEnabled = true;
				this.BalanceOption = "BalanceOnly";
			} else {
				this.EntireEnabled = true;
				this.BalanceEnabled = true;
			}
		} else {
			this.EntireEnabled = true;
			this.BalanceEnabled = false;
		}
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onRefund() {
		this.errorMessage = "";

		//Error handling

		let parms: AccountCreditRefundRequest = {
			AccountCreditID: this.SelectedFine.FineID,
			PersonID: this.SelectedPerson.PersonID,
			Administrator_PersonID: this.user.personID,
			RefundDT: moment(new Date()).format("MM/DD/YYYY HH:mm:00"),
			RefundComment: this.RefundComments,
			BalanceOnly: this.BalanceOption == "BalanceOnly" ? 1 : 0,
			SchoolID: this.SelectedPerson.SchoolID,
		};

		//Call SP
		var result = this.StudentFinesDebtsService.AccountCreditRefund(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "refund",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Payment was refunded successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "refund",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not refund the Payment",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////////////
}
